export type Countries = {
  [x: string]: {
    it: string;
    en: string;
    de: string;
    [x: string]: string | undefined;
  };
};

export const countries: Countries = {
  AD: { en: "Andorra", it: "Andorra", de: "Andorra" },
  AE: {
    en: "United Arab Emirates",
    it: "Emirati arabi uniti",
    de: "Vereinigte Arabische Emirate",
  },
  AF: { en: "Afghanistan", it: "Afghanistan", de: "Afghanistan" },
  AG: {
    en: "Antigua & Barbuda",
    it: "Antigua e Barbuda",
    de: "Antigua und Barbuda",
  },
  AI: { en: "Anguilla", it: "Anguilla", de: "Anguilla" },
  AL: { en: "Albania", it: "Albania", de: "Albanien" },
  AM: { en: "Armenia", it: "Armenia", de: "Armenien" },
  AN: {
    en: "Netherlands Antilles",
    it: "Antille olandesi",
    de: "Niederländische Antillen",
  },
  AO: { en: "Angola", it: "Angola", de: "Angola" },
  AQ: { en: "Antarctica", it: "Antartide", de: "Antarktis" },
  AR: { en: "Argentina", it: "Argentina", de: "Argentinien" },
  AS: { en: "American Samoa", it: "Samoa americane", de: "Amerikanisch-Samoa" },
  AT: { en: "Austria", it: "Austria", de: "Österreich" },
  AU: { en: "Australia", it: "Australia", de: "Australien" },
  AW: { en: "Aruba", it: "Aruba", de: "Aruba" },
  AZ: { en: "Azerbaijan", it: "Azerbaigian", de: "Aserbaidschan" },
  BA: {
    en: "Bosnia-Herzegovina",
    it: "Bosnia-Erzegovina",
    de: "Bosnien und Herzegowina",
  },
  BB: { en: "Barbados", it: "Barbados", de: "Barbados" },
  BD: { en: "Bangladesh", it: "Bangladesh", de: "Bangladesch" },
  BE: { en: "Belgium", it: "Belgio", de: "Belgien" },
  BF: { en: "Burkina Faso", it: "Burkina Faso", de: "Burkina Faso" },
  BG: { en: "Bulgaria", it: "Bulgaria", de: "Bulgarien" },
  BH: { en: "Bahrain", it: "Bahrein", de: "Bahrain" },
  BI: { en: "Burundi", it: "Burundi", de: "Burundi" },
  BJ: { en: "Benin", it: "Benin", de: "Benin" },
  BM: { en: "Bermuda", it: "Bermuda", de: "die Bermudas" },
  BN: { en: "Brunei", it: "Brunei", de: "Brunei Darussalam" },
  BO: { en: "Bolivia", it: "Bolivia", de: "Bolivien" },
  BR: { en: "Brazil", it: "Brasile", de: "Brasilien" },
  BS: { en: "Bahamas", it: "Bahamas", de: "Bahamas" },
  BT: { en: "Bhutan", it: "Bhutan", de: "Bhutan" },
  BW: { en: "Botswana", it: "Botswana", de: "Botsuana" },
  BY: { en: "Belarus", it: "Bielorussia", de: "Belarus" },
  BZ: { en: "Belize", it: "Belize", de: "Belize" },
  CA: { en: "Canada", it: "Canada", de: "Kanada" },
  CC: {
    en: "Cocos (Keeling) Island",
    it: "new Isole Cocos",
    de: "Kokosinseln",
  },
  CD: {
    en: "Congo (Dem. Rep.)",
    it: "Repubblica Democratica del Congo",
    de: "Demokratische Republik Kongo",
  },
  CF: {
    en: "Central Africa",
    it: "Repubblica Centrafricana",
    de: "Zentralafrikanische Republik",
  },
  CG: { en: "Congo", it: "Congo", de: "Kongo" },
  CH: { en: "Switzerland", it: "Svizzera", de: "Schweiz" },
  CI: { en: "Ivory Coast", it: "Costa d'Avorio", de: "Côte d'Ivoire" },
  CK: { en: "Cook Islands", it: "Isole Cook", de: "Cookinseln" },
  CL: { en: "Chile", it: "Cile", de: "Chile" },
  CM: { en: "Cameroon", it: "Camerun", de: "Kamerun" },
  CN: { en: "China", it: "Cina", de: "China" },
  CO: { en: "Colombia", it: "Colombia", de: "Kolumbien" },
  CR: { en: "Costa Rica", it: "Costa Rica", de: "Costa Rica" },
  CU: { en: "Cuba", it: "Cuba", de: "Kuba" },
  CV: { en: "Cape Verde", it: "Capo Verde", de: "Kap Verde" },
  CX: { en: "Christmas Island", it: "Isola Christmas", de: "Weihnachtsinsel" },
  CY: { en: "Cyprus", it: "Cipro", de: "Zypern" },
  CZ: {
    en: "Czech Republic",
    it: "Repubblica Ceca",
    de: "Tschechische Republik",
  },
  DE: { en: "Germany", it: "Germania", de: "Deutschland" },
  DJ: { en: "Djibouti", it: "Gibuti", de: "Dschibuti" },
  DK: { en: "Denmark", it: "Danimarca", de: "Dänemark" },
  DM: { en: "Dominica", it: "Dominica", de: "Dominica" },
  DO: {
    en: "Dominican Republic",
    it: "Repubblica Dominicana",
    de: "Dominikanische Republik",
  },
  DZ: { en: "Algeria", it: "Algeria", de: "Algerien" },
  EC: { en: "Ecuador", it: "Ecuador", de: "Ecuador" },
  EE: { en: "Estonia", it: "Estonia", de: "Estland" },
  EG: { en: "Egypt", it: "Egitto", de: "Ägypten" },
  EH: { en: "Sahara", it: "Sahara Occidentale", de: "Westsahara" },
  ER: { en: "Eritrea", it: "Eritrea", de: "Eritrea" },
  ES: { en: "Spain", it: "Spagna", de: "Spanien" },
  ET: { en: "Ethiopia", it: "Etiopia", de: "Äthiopien" },
  FI: { en: "Finland", it: "Finlandia", de: "Finnland" },
  FJ: { en: "Fiji", it: "Figi", de: "Fidschi" },
  FK: { en: "Falkland Islands", it: "Isole Falkland", de: "Falklandinseln" },
  FM: { en: "Micronesia", it: "Micronesia", de: "Mikronesien" },
  FO: { en: "Faroe Islands", it: "Faerøerne", de: "Färöer" },
  FR: { en: "France", it: "Francia", de: "Frankreich" },
  GA: { en: "Gabon", it: "Gabon", de: "Gabun" },
  GB: { en: "United Kingdom", it: "Regno Unito", de: "Vereinigtes Königreich" },
  GD: { en: "Grenada", it: "Grenada", de: "Grenada" },
  GE: { en: "Georgia", it: "Georgia", de: "Georgien" },
  GF: { en: "French Guiana", it: "Guiana Francese", de: "Französisch-Guayana" },
  GH: { en: "Ghana", it: "Ghana", de: "Ghana" },
  GI: { en: "Gibraltar", it: "Gibilterra", de: "Gibraltar" },
  GL: { en: "Greenland", it: "Groenlandia", de: "Grönland" },
  GM: { en: "Gambia", it: "Gambia", de: "Gambia" },
  GN: { en: "Guinea", it: "Guinea", de: "Guinea" },
  GP: { en: "Guadeloupe", it: "Guadalupa", de: "Guadeloupe" },
  GQ: {
    en: "Equatorial Guinea",
    it: "Guinea Equatoriale",
    de: "Äquatorialguinea",
  },
  GR: { en: "Greece", it: "Grecia", de: "Griechenland" },
  GT: { en: "Guatemala", it: "Guatemala", de: "Guatemala" },
  GU: { en: "Guam", it: "Guam", de: "Guam" },
  GW: { en: "Guinea Bissau", it: "Guinea Bissau", de: "Guinea-Bissau" },
  GY: { en: "Guyana", it: "Guyana", de: "Guyana" },
  HK: { en: "Hong Kong", it: "Hong Kong", de: "Hongkong" },
  HN: { en: "Honduras", it: "Honduras", de: "Honduras" },
  HR: { en: "Croatia", it: "Croazia", de: "Kroatien" },
  HT: { en: "Haiti", it: "Haiti", de: "Haiti" },
  HU: { en: "Hungary", it: "Ungheria", de: "Ungarn" },
  ID: { en: "Indonesia", it: "Indonesia", de: "Indonesien" },
  IE: { en: "Ireland", it: "Irlanda", de: "Irland" },
  IL: { en: "Israel", it: "Israele", de: "Israel" },
  IN: { en: "India", it: "India", de: "Indien" },
  IQ: { en: "Iraq", it: "Iraq", de: "Irak" },
  IR: { en: "Iran", it: "Iran", de: "Iran" },
  IS: { en: "Iceland", it: "Islanda", de: "Island" },
  IT: { en: "Italy", it: "Italia", de: "Italien" },
  JM: { en: "Jamaica", it: "Giamaica", de: "Jamaika" },
  JO: { en: "Jordan", it: "Giordania", de: "Jordanien" },
  JP: { en: "Japan", it: "Giappone", de: "Japan" },
  KE: { en: "Kenya", it: "Kenya", de: "Kenia" },
  KG: { en: "Kyrgyzstan", it: "Kirghizistan", de: "Kirgisistan" },
  KH: { en: "Cambodia", it: "Cambogia", de: "Kambodscha" },
  KI: { en: "Kiribati", it: "Kiribati", de: "Kiribati" },
  KM: { en: "Comoros", it: "Comore", de: "Komoren" },
  KN: {
    en: "Saint Kitts and Nevis",
    it: "Saint Christopher e Nevis",
    de: "St. Kitts und Nevis",
  },
  KP: {
    en: "Korea (North)",
    it: "Corea del Nord",
    de: "Demokratische Volksrepublik Korea",
  },
  KR: { en: "Korea (South)", it: "Corea del Sud", de: "Republik Korea" },
  KW: { en: "Kuwait", it: "Kuwait", de: "Kuwait" },
  KY: { en: "Cayman Islands", it: "Isole Cayman", de: "Kaimaninseln" },
  KZ: { en: "Kazakhstan", it: "Kazakistan", de: "Kasachstan" },
  LA: { en: "Laos", it: "Laos", de: "Laos" },
  LB: { en: "Lebanon", it: "Libano", de: "Libanon" },
  LC: { en: "Saint Lucia", it: "Saint Lucia", de: "St. Lucia" },
  LI: { en: "Liechtenstein", it: "Liechtenstein", de: "Liechtenstein" },
  LK: { en: "Sri Lanka", it: "Sri Lanka", de: "Sri Lanka" },
  LR: { en: "Liberia", it: "Liberia", de: "Liberia" },
  LS: { en: "Lesotho", it: "Lesotho", de: "Lesotho" },
  LT: { en: "Lithuania", it: "Lituania", de: "Litauen" },
  LU: { en: "Luxembourg", it: "Lussemburgo", de: "Luxemburg" },
  LV: { en: "Latvia", it: "Lettonia", de: "Lettland" },
  LY: { en: "Libya", it: "Libia", de: "Libyen" },
  MA: { en: "Morocco", it: "Marocco", de: "Marokko" },
  MC: { en: "Monaco", it: "Monaco", de: "Monaco" },
  MD: { en: "Moldova", it: "Moldavia", de: "Republik Moldau" },
  ME: { en: "Montenegro", it: "Montenegro", de: "Montenegro" },
  MG: { en: "Madagascar", it: "Madagascar", de: "Madagaskar" },
  MH: { en: "Marshall Islands", it: "Isole Marshall", de: "Marshallinseln" },
  MK: { en: "Macedonia", it: "Macedonia", de: "Macedonia" },
  ML: { en: "Mali", it: "Mali", de: "Mali" },
  MM: { en: "Myanmar", it: "Birmania", de: "Myanmar" },
  MN: { en: "Mongolia", it: "Mongolia", de: "Mongolei" },
  MP: {
    en: "Northern Mariana Islands",
    it: "Isole Marianne Settentrionali",
    de: "Nördliche Marianen",
  },
  MQ: { en: "Martinique", it: "Martinica", de: "Martinique" },
  MR: { en: "Mauritania", it: "Mauritania", de: "Mauretanien" },
  MS: { en: "Montserrat", it: "Monserrat", de: "Montserrat" },
  MT: { en: "Malta", it: "Malta", de: "Malta" },
  MU: { en: "Mauritius", it: "Maurizio", de: "Mauritius" },
  MV: { en: "Maldives", it: "Maldive", de: "Malediven" },
  MW: { en: "Malawi", it: "Malawi", de: "Malawi" },
  MX: { en: "Mexico", it: "Messico", de: "Mexiko" },
  MY: { en: "Malaysia", it: "Malesia", de: "Malaysia" },
  MZ: { en: "Mozambique", it: "Mozambico", de: "Mosambik" },
  NA: { en: "Namibia", it: "Namibia", de: "Namibia" },
  NC: { en: "New Caledonia", it: "Nuova Caledonia", de: "Neukaledonien" },
  NE: { en: "Niger", it: "Niger", de: "Niger" },
  NF: { en: "Norfolk", it: "Isola Norfolk", de: "Norfolkinsel" },
  NG: { en: "Nigeria", it: "Nigeria", de: "Nigeria" },
  NI: { en: "Nicaragua", it: "Nicaragua", de: "Nicaragua" },
  NL: { en: "Netherlands", it: "Paesi Bassi", de: "Niederlande" },
  NO: { en: "Norway", it: "Norvegia", de: "Norwegen" },
  NP: { en: "Nepal", it: "Nepal", de: "Nepal" },
  NR: { en: "Nauru", it: "Nauru", de: "Nauru" },
  NU: { en: "Niue", it: "Niue", de: "Niue" },
  NZ: { en: "New Zealand", it: "Nuova Zelanda", de: "Neuseeland" },
  OM: { en: "Oman", it: "Oman", de: "Oman" },
  PA: { en: "Panama", it: "Panama", de: "Panama" },
  PE: { en: "Peru", it: "Perù", de: "Peru" },
  PF: {
    en: "French Polynesia",
    it: "Polinesia francese",
    de: "Französisch-Polynesien",
  },
  PG: {
    en: "Papua New Guinea",
    it: "Papua Nuova Guinea",
    de: "Papua-Neuguinea",
  },
  PH: { en: "Philippines", it: "Filippine", de: "Philippinen" },
  PK: { en: "Pakistan", it: "Pakistan", de: "Pakistan" },
  PL: { en: "Poland", it: "Polonia", de: "Polen" },
  PM: {
    en: "Saint Pierre & Miquelon",
    it: "Saint-Pierre e Miquelon",
    de: "St. Pierre und Miquelon",
  },
  PN: { en: "Pitcairn Islands", it: "Isole Pitcairn", de: "Pitcairninseln" },
  PR: { en: "Puerto Rico", it: "Portorico", de: "Puerto Rico" },
  PS: { en: "Palestine", it: "Palestina", de: "Palästina" },
  PT: { en: "Portugal", it: "Portogallo", de: "Portugal" },
  PW: { en: "Palau", it: "Palau", de: "Palau" },
  PY: { en: "Paraguay", it: "Paraguay", de: "Paraguay" },
  QA: { en: "Qatar", it: "Qatar", de: "Katar" },
  RE: { en: "Rèunion", it: "Riunione", de: "Réunion" },
  RO: { en: "Romania", it: "Romania", de: "Rumänien" },
  RS: { en: "Serbia", it: "Serbia", de: "Serbien" },
  RU: { en: "Russia", it: "Russia", de: "Russische Föderation" },
  RW: { en: "Rwanda", it: "Ruanda", de: "Ruanda" },
  SA: { en: "Saudi Arabia", it: "Arabia Saudita", de: "Saudi-Arabien" },
  SB: { en: "Solomon Islands", it: "Isole Salomone", de: "Salomonen" },
  SC: { en: "Seychelles", it: "Seicelle", de: "Seychellen" },
  SD: { en: "Sudan", it: "Sudan", de: "Sudan" },
  SE: { en: "Sweden", it: "Svezia", de: "Schweden" },
  SG: { en: "Singapore", it: "Singapore", de: "Singapur" },
  SH: { en: "Saint Helena", it: "Sant'Elena", de: "St. Helena" },
  SI: { en: "Slovenia", it: "Slovenia", de: "Slowenien" },
  SJ: {
    en: "Svalbard and Jan Mayen",
    it: "Svalbard e Jan Mayen",
    de: "Svalbard und Jan Mayen",
  },
  SK: { en: "Slovakia", it: "Slovacchia", de: "Slowakei" },
  SL: { en: "Sierra Leone", it: "Sierra Leone", de: "Sierra Leone" },
  SM: { en: "San Marino", it: "San Marino", de: "San Marino" },
  SN: { en: "Senegal", it: "Senegal", de: "Senegal" },
  SO: { en: "Somalia", it: "Somalia", de: "Somalia" },
  SR: { en: "Suriname", it: "Suriname", de: "Suriname" },
  SS: { en: "South Sudan", it: "Sudan del Sud", de: "Südsudan" },
  ST: {
    en: "Sào Tomè and Prìncipe",
    it: "São Tomé e Príncipe",
    de: "São Tomé und Príncipe",
  },
  SV: { en: "El Salvador", it: "El Salvador", de: "El Salvador" },
  SY: { en: "Syria", it: "Siria", de: "Syrien" },
  SZ: { en: "Swaziland", it: "Swaziland", de: "Swasiland" },
  TC: {
    en: "Turks and Caicos Islands",
    it: "Isole Turks e Caicos",
    de: "Turks und Caicosinseln",
  },
  TD: { en: "Chad", it: "Ciad", de: "Tschad" },
  TF: {
    en: "Terres Australes",
    it: "Territori Australi Francesi",
    de: "Französische Gebiete im südlichen Indischen  Ozean",
  },
  TG: { en: "Togo", it: "Togo", de: "Togo" },
  TH: { en: "Thailand", it: "Thailandia", de: "Thailand" },
  TJ: { en: "Tajikistan", it: "Tagikistan", de: "Tadschikistan" },
  TK: { en: "Tokelau", it: "Tokelau", de: "Tokelau" },
  TM: { en: "Turkmenistan", it: "Turkmenistan", de: "Osttimor" },
  TN: { en: "Tunisia", it: "Tunisia", de: "Turkmenistan" },
  TO: { en: "Tonga", it: "Tonga", de: "Tunesien" },
  TP: { en: "East Timor", it: "Timor Est", de: "Tonga" },
  TR: { en: "Turkey", it: "Turchia", de: "Türkei" },
  TT: {
    en: "Trinidad and Tobago",
    it: "Trinidad e Tobago",
    de: "Trinidad und Tobago",
  },
  TV: { en: "Tuvalu", it: "Tuvalu", de: "Tuvalu" },
  TW: { en: "Taiwan", it: "Taiwan", de: "Taiwan" },
  TZ: { en: "Tanzania", it: "Tanzania", de: "Tansania" },
  UA: { en: "Ukraine", it: "Ucraina", de: "Ukraine" },
  UG: { en: "Uganda", it: "Uganda", de: "Uganda" },
  US: {
    en: "United States of America",
    it: "Stati Uniti",
    de: "Vereinigte Staaten",
  },
  UY: { en: "Uruguay", it: "Uruguay", de: "Uruguay" },
  UZ: { en: "Uzbekistan", it: "Uzbekistan", de: "Usbekistan" },
  VA: { en: "Vatican", it: "Vaticano", de: "Vatikanstadt" },
  VC: {
    en: "St. Vincent & the Grenadines",
    it: "Saint Vincent e Grenadine",
    de: "St. Vincent und die Grenadinen",
  },
  VE: { en: "Venezuela", it: "Venezuela", de: "Venezuela" },
  VG: {
    en: "British Virgin Islands",
    it: "Isole Vergini britanniche",
    de: "Britische Jungferninseln",
  },
  VI: {
    en: "Virgin Islands of the USA",
    it: "Isole Vergini Americane",
    de: "Amerikanische Jungferninseln",
  },
  VN: { en: "Vietnam", it: "Vietnam", de: "Vietnam" },
  VU: { en: "Vanuatu", it: "Vanuatu", de: "Vanuatu" },
  WF: { en: "Wallis & Futuna", it: "Wallis e Futuna", de: "Wallis und Futuna" },
  WS: { en: "Samoa", it: "Samoa", de: "Samoa" },
  XA: {
    en: "Ext. Territ. of Australia",
    it: "Ext. Territ. of Australia",
    de: "Ext. Territ. of Australia",
  },
  XG: {
    en: "Smaller Territories of the UK",
    it: "Smaller Territories of the UK",
    de: "Smaller Territories of the UK",
  },
  XJ: { en: "Jersey", it: "Isola di Jersey", de: "Jersey" },
  XK: { en: "Kosovo", it: "Kosovo", de: "Kosovo" },
  XM: { en: "Man (Isle of)", it: "Isola di Man", de: "Isle of Man" },
  XU: {
    en: "Guernsey and Alderney",
    it: "Guernsey e Alderney",
    de: "Guernsey und Alderney",
  },
  YE: { en: "Yemen", it: "Yemen", de: "Jemen" },
  YT: { en: "Mayotte", it: "Mayotte", de: "Jugoslawien" },
  ZA: { en: "South Africa", it: "Sudafrica", de: "Südafrika" },
  ZM: { en: "Zambia", it: "Zambia", de: "Sambia" },
  ZW: { en: "Zimbabwe", it: "Zimbabwe", de: "Simbabwe" },
};
